import { render, staticRenderFns } from "./ConfigPage.vue?vue&type=template&id=a2051932&lang=pug"
import script from "./ConfigPage.vue?vue&type=script&lang=js"
export * from "./ConfigPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2051932')) {
      api.createRecord('a2051932', component.options)
    } else {
      api.reload('a2051932', component.options)
    }
    module.hot.accept("./ConfigPage.vue?vue&type=template&id=a2051932&lang=pug", function () {
      api.rerender('a2051932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/data_quality_dataplex/ConfigPage.vue"
export default component.exports